import { createSlice } from '@reduxjs/toolkit';

interface MainState {
    menuModal: any;
    infoModal: any;
    AGmodal: any;
}

const initialState: MainState = {
    menuModal: {
        open: false
    },
    infoModal: {
        open: false
    },
    AGmodal: {
        open: false,
        id: null
    },
};

export const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        setMenuModalOpen: (state, actions) => {
            state.menuModal.open = JSON.parse(actions.payload);
        },
        setInfoModalOpen: (state, actions) => {
            state.infoModal.open = JSON.parse(actions.payload);
        },
        setAGModalOpen: (state, actions) => {
            state.AGmodal.open = JSON.parse(actions.payload);
        },
        setAGModalId: (state, actions) => {
            state.AGmodal.id = JSON.parse(actions.payload);
        },
    },
});

export const { setMenuModalOpen, setInfoModalOpen, setAGModalOpen, setAGModalId } = mainSlice.actions;

export default mainSlice.reducer;

export const mainSelector = (state: any) => state.main;

export function MenuModalOpen(open: boolean) {
    return async (dispatch: any) => {
        try {
            dispatch(setMenuModalOpen(JSON.stringify(open)));
        } catch (error) {
            console.log(error);
        }
    };
}

export function InfoModalOpen(open: boolean) {
    return async (dispatch: any) => {
        try {
            dispatch(setInfoModalOpen(JSON.stringify(open)));
        } catch (error) {
            console.log(error);
        }
    };
}

export function AGModalOpen(open: boolean) {
    return async (dispatch: any) => {
        try {
            dispatch(setAGModalOpen(JSON.stringify(open)));
        } catch (error) {
            console.log(error);
        }
    };
}

export function AGModalId(id: any) {
    return async (dispatch: any) => {
        try {
            dispatch(setAGModalId(JSON.stringify(id)));
        } catch (error) {
            console.log(error);
        }
    };
}